import moment from 'moment-timezone';

const timezones = moment.tz.names().map((tz: string) => ({
  label: tz,
  value: tz,
}));

export default timezones;